module.exports = () => {
  return {
    app_name: 'Univention',
    styles: {
      load: () => import(/* webpackChunkName: "styleUnivention" */'src/config/brandings/univention/index.scss')
    },
    meta: {
      meta: [
        { name: 'apple-itunes-app', content: 'app-id=1145264453' },
        { name: 'og:image', content: '/favicons/favicon_192x192.png' },
        { name: 'twitter:image', content: '/favicons/favicon_192x192.png' }
      ],
      link: [
        { rel: 'shortcut icon', href: '/favicon.ico' }
      ]
    },
    logos: {
      logo: 'brandings/default/logo/sdui-seven-education-logo.svg'
    },
    search: {
      queries: {
        branding: null
      }
    },
    start: {
      description: 'public.start.security',
      image: 'brandings/default/start/sdui-start-image.jpg',
      show_more: true,
      sdui_authenticator: false
    },
    management: {
      show_announcements: true,
      show_material_page: true,
      additional_content: {
        infos: 'management.additional_content.infos'
      }
    },
    ui: {
      show_hint_cards: true,
      show_video_hint: true
    },
    settings: {
      notifications: {
        email_newsletter: false
      }
    },
    dataProtection: {
      show_go_to_sdui_website: true
    },
    onboarding: {
      help_videos: true
    },
    keepAlivePing: false,
    appSwitcher: {
      show_marketing: false
    },
    login: {
      registration_code: true,
      hideSduiLoginDefault: false,
      sduiLoginDefaultExpanded: false,
      form: {
        inline_reset_password: true
      }
    }
  }
}
